import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { AboutPreview } from '../components/AboutPreview';
import { Members } from '../components/Members';
import { Partners } from '../components/Partners';
import { Projects } from '../components/Projects';
import { Events } from '../components/Events';
import { NewsPreview } from '../components/NewsPreview';
import { JoinCluster } from '../components/JoinCluster';
import { FAQ } from '../components/FAQ';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
import { FloatingWidgets } from '../components/FloatingWidgets';
export function LandingPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-354">
      <Navigation data-id="element-355" />
      <FloatingWidgets data-id="element-356" />
      <main data-id="element-357">
        <Hero data-id="element-358" />
        <AboutPreview data-id="element-359" />
        <Members data-id="element-360" />
        <Partners data-id="element-361" />
        <Projects data-id="element-362" />
        <Events data-id="element-363" />
        <NewsPreview data-id="element-364" />
        <JoinCluster data-id="element-365" />
        <FAQ data-id="element-366" />
        <ContactSection data-id="element-367" />
      </main>
      <Footer data-id="element-368" />
    </div>;
}